import { useNavigate } from "react-router-dom";
import CardSection from "../design/CardSection";
import Logo from "../design/Logo";

const CooperativeLearning = () => {
  const navigate = useNavigate();
  const textArray = ["협", "력", "학", "습"];
  const onHomeClick = () => {
    navigate("/fun_learning/home");
  };

  const onFunlearningAloneClick = () => {
    navigate("/fun_learning/funlearningalone");
  };

  const onMyInfoClick = () => {
    navigate("/fun_learning/myinfo");
  };

  const goToComingSoon = () => {
    navigate("/fun_learning/comingsoon");
  };

  const cardSectionDataCooperation = {
    title: "협력학습",
    description: "친구들과 경쟁하며 재밌게 학습해보세요!",
    emoji: "🏆",
    listItems: [
      "개인전과 팀전을 통한 학습!",
      "학습후 포인트를 통해 순위올리기!",
      "초등단어부터 고등단어까지!",
      "신나게 학습하다보면 단어가 머리속에!",
      "보카톡톡만의 동시 플레이 학습!",
    ],
    buttonText: "협력학습 시작하기",
    onClick: onHomeClick,
  };

  const cardSectionDataGame = {
    title: "즐거운 학습",
    description: "지루한 학습은 no! 재미있게 보카톡톡으로!",
    emoji: "🕺",
    listItems: [
      "다양한 종류의 즐거운 학습!",
      "소나기, 카드 뒤집기등 최적화 즐거운 학습!",
      "게임도 하고 단어학습도하고!",
      "수준별 단어 공부와 재미까지!",
      "놀다보면 10000단어가 머리에?",
    ],
    buttonText: "즐거운 학습 시작하기",
    onClick: onFunlearningAloneClick,
  };

  const cardSectionDataHabituation = {
    title: "습관화",
    description: "보카톡톡만의 레벨로 공부하는 습관기르기!",
    emoji: "📝",
    listItems: [
      "학습을 하면 레벨이증가!",
      "매일 매일 출석시 레벨 up!",
      "언제 학습했는지 한눈에 볼 수 있는 테이블!",
      "레벨업 기능을 통한 자발적인 학습습관 정착!",
      "보카톡톡으로 학습습관까지!",
    ],
    buttonText: "학습 시작하기",
    onClick: onHomeClick,
  };

  const cardSectionDataLeveing = {
    title: "수준맞춤",
    description: "더욱 세분화된 단어데이터로 수준맞춤학습!",
    emoji: "📈",
    listItems: [
      "타사와 비교하여 세분화되어있는 단어!",
      "초등부터 고등 수능단어까지 수준별학습!",
      "다년간의 학습데이터로 엄선된 단어!",
      "보다 정확하고 맞는 단어데이터!",
      "보카톡톡에서 완전학습!",
    ],
    buttonText: "학습 시작하기",
    onClick: onHomeClick,
  };

  const cardSectionDataCertificates = {
    title: "수료증 및 뱃지",
    description: "단어장을 학습할때마다 수료증및 뱃지 획득!",
    emoji: "🎖️",
    listItems: [
      "500문제 이상 학습시 뱃지 획득!",
      "정답률이 80% 이상일시 수료증 획득!",
      "나의 정보에서 한눈에 업적확인!",
      "수료증에 다양한 장학혜택까지!",
      "어떤 단어를 학습했는지 한눈에!",
    ],
    buttonText: "나의 수료현황 보러가기",
    onClick: onMyInfoClick,
  };

  const cardSectionDatascholarship = {
    title: "장학제도",
    description: "즐겁게 학습 후 장학제도 혜택까지 받아가자!",
    emoji: "🎓",
    listItems: [
      "열심히 익힌자, 누릴자격이 있다!",
      "수료증 및 뱃지를 통한 장학제도!",
      "상위 랭커에게 또한 장학 혜택이!",
      "꾸준히 학습하기만 해도 혜택이!",
      "보카톡톡에서 얻어가며 학습하자!",
    ],
    buttonText: "더알아보기",
    onClick: goToComingSoon,
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            효과적인 학습을 위해선 협력학습!
          </h2>

          <div className=" pt-10 font-bold text-gray-600 sm:text-xl dark:text-gray-400">
            준비가 되었다면?
          </div>
          <button
            onClick={onHomeClick}
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:bg-gradient-to-b dark:shadow-blue-900 shadow-blue-200 hover:shadow-2xl hover:shadow-blue-400 hover:-tranneutral-y-px "
          >
            협력학습실로 이동하기!
          </button>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            협력학습이란
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            협력, 경쟁, 즐거운 학습, 습관화, 수준맞춤 전부 갖춘 유일한 단어 학습
            프로그램
          </p>
        </div>

        <div className="mb-20 flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
          <h3 className="mb-4 text-2xl font-semibold">
            놀라운 학습법을 한곳에!
          </h3>

          <div className="flex items-baseline justify-center my-8 ">
            <span className="mr-2 text-8xl font-extrabold">📔</span>
          </div>

          <ul role="list" className="mb-8 space-y-4 text-left">
            <li className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>친구들과 함께 즐기는 협력학습!</span>
            </li>
            <li className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>게임을 통한 재밌는 학습!</span>
            </li>
            <li className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>다양한 단어장으로 수준별 학습!</span>
            </li>
            <li className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>수료증 발급을 통한 장학제도!</span>
            </li>
            <li className="flex items-center space-x-3">
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span>이 모든걸 통해 학습이 아닌 습관으로!</span>
            </li>
          </ul>
        </div>

        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            더 자세하게 알아보기
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            보카톡톡의 협력학습, 즐거운 학습, 습관화, 수준맞춤, 수료증,
            장학제도를 자세하게 알아보세요!
          </p>
        </div>

        <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
          <CardSection {...cardSectionDataCooperation} />
          <CardSection {...cardSectionDataGame} />
          <CardSection {...cardSectionDataHabituation} />
          <CardSection {...cardSectionDataLeveing} />
          <CardSection {...cardSectionDataCertificates} />
          <CardSection {...cardSectionDatascholarship} />
        </div>
      </div>
    </section>
  );
};

export default CooperativeLearning;
